// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3JiAi","large":"styles_large__P1VbW"};